export default {
      id: "big-arrow-left-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#big-arrow-left",
      toString: function () {
        return this.url;
      }
    }